module.exports = __webpack_public_path__ + "img/31.42d744f4.png";